/* @flow */

export default class SubmitFixInvoiceRequest {
  invoiceId: number;
  isFinanced: boolean;
  requiresToPay: boolean;

  constructor(invoiceId: number, isFinanced: boolean, requiresToPay: boolean) {
    this.invoiceId = invoiceId;
    this.isFinanced = isFinanced;
    this.requiresToPay = requiresToPay;
  }
}
